import { UnitQty } from '@tcc/i18n';

let unitQty = new UnitQty('imperial', 'US'); // default setting

// FOR TESTING PURPOSES ONLY!!
let _mockLocale; // undefined by default

/**
 * Redefine unitQty instance to a new UoM and country
 * @param {String} unitsOfMeasureTemplate
 * @param {String} countryCode
 * @return {undefined}
 */
export const setUnitQty = (unitsOfMeasureTemplate, countryCode) => {
  unitQty = new UnitQty(unitsOfMeasureTemplate, countryCode, _mockLocale);
};

/**
 * Returns new QtyFactory instance using a unitKey
 * @param {Number|String} scalar
 * @param {String} unitKey
 * @param {Number} [precision]
 * @return {QtyFactory}
 */
export const createUnit = (scalar, unitKey, precision) =>
  unitQty.createUnit(scalar, unitKey, precision);

/**
 * Returns new QtyFactory instance using a displayUnitType
 * @param {String} displayUnitType
 * @param {Number|String} scalar
 * @return {QtyFactory}
 */
export const inferUnit = (displayUnitType, scalar) =>
  unitQty.inferUnit(displayUnitType, scalar);
